/**
 * Data-driven route config — Plan 04-02 / CUPONS-01.
 * Consumed by:
 *   - src/ssg.tsx (vite-react-ssg SSG entry — build-time static path emission)
 *   - src/App.tsx (BrowserRouter dev + SPA mode)
 */
import type { RouteRecord } from "vite-react-ssg";
import Index from "@/pages/Index";
import Redirector from "@/pages/Redirector";
import Camping from "@/pages/Camping";
import NotFound from "@/pages/NotFound";

export const routes: RouteRecord[] = [
  { path: "/", Component: Index, entry: "src/main.tsx" },
  { path: "/r/:slug", Component: Redirector },
  // Landing do grupo de Camping — só WhatsApp, paleta própria (rota sem params →
  // SSG emite /camping/index.html).
  { path: "/camping", Component: Camping },
  // /cupons e /cupons/<loja>/<categoria> saíram do ar em 2026-10-23 (com o bot
  // desligado, mostravam ofertas vencidas). public/_redirects manda para a home.
  { path: "*", Component: NotFound },
];
